// tslint:disable
import { Component, Injector } from '@angular/core';

import { CMFormEditComponent, CMInputConfig
       } from './../../@cmcore/component';

@Component({
    selector: 'cfop-edit',
    templateUrl: 'cfop-edit.component.html',
})
export class CFOPEditComponent extends CMFormEditComponent {

  getFirstComponentName() {
    return 'model_codigo';
  }

  getTitle() {
    return 'CFOP';
  }

  constructor(_injector: Injector) {
    super(_injector);
    this.controllerName = 'cfop';
    this.modelConfig = {
      codigo: new CMInputConfig({form: this,
                                 caption: '#',
                                 required: true,
                                 mask: '9.999'}),
      descricao: new CMInputConfig({form: this,
                                    caption: 'Descrição',
                                    required: true,
                                    maxlength: 255}),
      tpoperacao: new CMInputConfig({form: this,
                                     caption: 'Tipo de Operação',
                                     values: [{'value': "Entrada"},
                                              {'value': "Saida", 'text': "Saída"}]}),
      finalidade: new CMInputConfig({form: this,
                                     caption: 'Finalidade',
                                     values: [{'value': "Normal"},
                                              {'value': "Devolucao", 'text': "Devolução"}]}),
      servico: new CMInputConfig({form: this,
                                  caption: 'é de Servico'}),
      ativo: new CMInputConfig({form: this,
                                caption: 'Ativo'}),
    };
  }

}